// dependencies
import { useParams } from "react-router-dom";

//hooks
import { useCurrentUser } from "../../../../../api/hooks";

//utils
import isValidObjectID from "../../../../../utils/isValidObjectID";

// This hook handles the navigation parameters for the user reviews page.
const useUserReviewsNavigationParams = () => {
	const { data: me, isLoading } = useCurrentUser();

	const { paramA, paramB } = useParams();

	const userId = me?.me?.authorization?.payload?.user_id;
	const employeeId = isValidObjectID(paramA) ? paramA : userId;
	let activePage = paramB;

	// need to have a default activePage pathing
	// for dual screen navigation. Will not contain
	// path coming from there.
	if (!paramB) {
		if (employeeId === userId) {
			activePage = "forms-i-need-to-do";
		} else {
			activePage = "reviews-of-me";
		}
	}

	return {
		userId,
		employeeId,
		activePage,
		isLoading,
	};
};

export default useUserReviewsNavigationParams;
